import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { type RatingCorrection, type RatingReset, ratings } from "../../../admin-api/ratings";
import { queryKeys } from "../../query-keys";

const ratingKeys = {
	all: (id: string) => ["admin-ratings", id] as const,
	changes: (id: string, offset: number) => [...ratingKeys.all(id), "changes", offset] as const,
	current: (id: string) => [...ratingKeys.all(id), "current"] as const,
	overview: () => ["admin-ratings", "overview"] as const,
};
export function useRatingOverview() {
	return useQuery({ queryFn: () => ratings.overview(), queryKey: ratingKeys.overview() });
}
export function useRating(id: string) {
	return useQuery({ queryFn: () => ratings.get(id), queryKey: ratingKeys.current(id) });
}
export function useRatingChanges(id: string, offset: number) {
	return useQuery({
		queryFn: () => ratings.changes(id, offset),
		queryKey: ratingKeys.changes(id, offset),
	});
}
export function useRatingAdjustments(id: string) {
	const client = useQueryClient();
	const refresh = () => {
		void client.invalidateQueries({ queryKey: ratingKeys.all(id) });
		void client.invalidateQueries({ queryKey: ratingKeys.overview() });
		void client.invalidateQueries({ queryKey: queryKeys.profiles.all });
	};
	const correction = useMutation({
		mutationFn: (body: RatingCorrection) => ratings.correct(id, body),
		onSuccess: refresh,
	});
	const reset = useMutation({
		mutationFn: (body: RatingReset) => ratings.reset(id, body),
		onSuccess: refresh,
	});
	return { correction, reset };
}
